import { COUPON_TYPES } from '../../../../services/exports/Constants';

const Coupons: Record<COUPON_TYPES, string> = {
  [COUPON_TYPES.PROMO_CODE]: 'Promo code {{code}} applied',
  [COUPON_TYPES.CASHBACK]: 'Loyalty points applied',
  [COUPON_TYPES.REWARD]: 'Reward applied',
  [COUPON_TYPES.GIFT_CARD]: 'Gift card applied',
};

export default Coupons;
